import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPost } from "./postDetailsAPI";
import { saveBlogPost } from "../save/saveAPI";
import { likeBlogPost } from "../likes/likesAPI";
const initialState = {
  isLoading: false,
  post: {},
  error: "",
};

export const fetchPost = createAsyncThunk("post/fetchPost", async (id) => {
  const post = await getPost(id);
  return post;
});

export const savePost = createAsyncThunk(
  "post/savePost",
  async ({ id, payload }) => {
    const post = await saveBlogPost(id, payload);
    return post;
  }
);
export const likePost = createAsyncThunk(
  "post/likePost",
  async ({ id, payload }) => {
    const post = await likeBlogPost(id, payload);
    return post;
  }
);

export const postSlice = createSlice({
  name: "post",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchPost.pending, (state) => {
        state.isLoading = true;
        state.post = {};
        state.error = "";
      })
      .addCase(fetchPost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.post = action.payload;
        state.error = "";
      })
      .addCase(fetchPost.rejected, (state, action) => {
        state.isLoading = false;
        state.post = {};
        state.error = action.error?.message;
      })
      .addCase(savePost.pending, (state) => {
        state.isLoading = true;
        state.post = {};
        state.error = "";
      })
      .addCase(savePost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.post = action.payload;
        state.error = "";
      })
      .addCase(savePost.rejected, (state, action) => {
        state.isLoading = false;
        state.post = {};
        state.error = action.error?.message;
      })
      .addCase(likePost.pending, (state) => {
        state.isLoading = true;
        state.post = {};
        state.error = "";
      })
      .addCase(likePost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.post = action.payload;
        state.error = "";
      })
      .addCase(likePost.rejected, (state, action) => {
        state.isLoading = false;
        state.post = {};
        state.error = action.error?.message;
      });
  },
});

export default postSlice.reducer;
